// extracted by mini-css-extract-plugin
module.exports = {"paginator-container":"paginator_paginator-container__1V9ts"};